<div class="flex flex-col gap-2 bg-neutral-800 rounded-sm p-2">
  <div class="flex justify-between items-center">
    <div class="text-lg font-bold">
      {{ 'internal.inventory.missingItems.title' | translate }}
    </div>

    <div class="flex gap-2">
      <p-button
        [outlined]="true"
        [disabled]="selectedItems().length <= 0"
        (onClick)="printLabelsAll()"
      >
        {{ 'internal.inventory.printLabels' | translate }}
      </p-button>
    </div>
  </div>

  <div class="h-1 bg-neutral-950"></div>

  <div class="flex flex-col gap-2">
    @if (loadingTransactions()) {
      <p-skeleton height="2.5rem" />
      <p-skeleton height="2.5rem" />
      <p-skeleton height="2.5rem" />
    } @else {
      @for (types of itemTypes(); track types) {
        <div class="item pt-2 rounded-sm">
          <div class="flex flex-row gap-2 cursor-pointer" (click)="toggleCollapse(types._id)">
            <mat-icon>{{ !expandedTypes()[types._id] ? 'expand_more' : 'expand_less' }}</mat-icon>
            <span>{{ itemTypesCount()[types._id] }}x </span>
            <span class="font-semibold">{{ types.name }}</span>
            <span class="text-muted-color">{{ types.additionalInfo }}</span>
          </div>
          <div
            class="instance-list flex flex-col mt-2 ml-4"
            [class.collapsed]="!expandedTypes()[types._id]"
          >
            @for (instance of itemFilter(types._id); track instance) {
              <div class="instance flex items-center h-10 rounded-sm gap-2">
                <p-checkbox
                  [ngModel]="selectedItems().includes(instance)"
                  (onChange)="instanceSelected(types._id, instance.instanceID, $event.checked)"
                  [binary]="true"
                />
                <div class="font-semibold">{{ types.name }}</div>
                <div class="text-muted-color">{{ instance.instanceID }}</div>
                <div class="ml-auto flex justify-end items-center gap-2">
                  <p-button
                    [pt]="{ root: { style: { padding: '4px' } } }"
                    [rounded]="true"
                    [text]="true"
                    (onClick)="showTransaction(instance.transaction)"
                  >
                    <mat-icon color="white"> visibility </mat-icon>
                  </p-button>
                </div>
              </div>
            }
          </div>
        </div>
      } @empty {
        <empty-state
          [icon]="'search_off'"
          [title]="'internal.inventory.missingItems.empty.title' | translate"
          [subtitle]="'internal.inventory.missingItems.empty.subtitle' | translate"
        >
        </empty-state>
      }
    }
  </div>
</div>
<div class="flex justify-end gap-2 mt-4">
  <p-button
    [label]="'general.close' | translate"
    severity="secondary"
    (onClick)="dialogRef.close()"
  />
</div>
